module.exports = __webpack_public_path__ + "static/media/daring-expo-west.0ff1cb86.png";